
import { db } from '../../lib/firebase';
import { Announcement } from '../../types';

export const getAnnouncements = async (userId: string): Promise<Announcement[]> => {
    const snap = await db.collection('announcements')
        .where('userId', '==', userId)
        .orderBy('createdAt', 'desc')
        .get();
    return snap.docs.map(d => ({ id: d.id, ...d.data() } as Announcement));
};

export const createAnnouncement = async (
    userId: string, 
    content: string, 
    linkedService?: {id: string, title: string},
    schedule?: { start?: number, end?: number }
) => {
    // 1. Check Limit
    const existing = await getAnnouncements(userId);
    if (existing.length >= 3) {
        throw new Error("Maximum of 3 announcements allowed (Active or Scheduled). Please delete one.");
    }

    const now = Date.now();
    const start = schedule?.start || now;
    
    // Auto-activate if start time is now or past, otherwise pending
    const active = start <= now;

    // 2. Create
    await db.collection('announcements').add({
        userId,
        content,
        linkedServiceId: linkedService?.id || null,
        linkedServiceName: linkedService?.title || null,
        active,
        scheduledStart: start,
        scheduledEnd: schedule?.end || null,
        createdAt: now
    });
};

export const deleteAnnouncement = async (id: string) => {
    await db.collection('announcements').doc(id).delete();
};
